// @ core
const apiURLBuilder = require("core/apiURLBuilder");

// @ actions
const signaturePatternActions = require("actions/signaturePattern");

// @ utilities
const { APIPost, APIGet } = require("utilities/APIRequestHelper");

// @ constants
const actionTypes = require("constants/actionTypes");

const requestSolidarityCardFetching = () => {
    return {
        type: actionTypes.OK_WIZARD_REQUEST_SOLIDARITY_CARD_FETCHING
    };
};

const requestSolidarityCardSuccess = payload => {
    return {
        type: actionTypes.OK_WIZARD_REQUEST_SOLIDARITY_CARD_SUCCESS,
        payload
    };
};

const requestSolidarityCardError = () => {
    return {
        type: actionTypes.OK_WIZARD_REQUEST_SOLIDARITY_CARD_ERROR
    };
};

const requestSolidarityCardNotFound = () => {
    return {
        type: actionTypes.OK_WIZARD_REQUEST_SOLIDARITY_CARD_NOT_FOUND
    };
};

const requestSolidarityCard = data => dispatch => {
    dispatch(requestSolidarityCardFetching());

    return APIGet({
        dispatch,
        endpoint: "cardsSolidarityData",
        url: apiURLBuilder.getURL("cardsSolidarityData", {
            data
        })
    })
        .then(response => dispatch(requestSolidarityCardSuccess(response)))
        .catch(error => {
            if (error.error.status === 400) {
                dispatch(requestSolidarityCardNotFound());
            } else {
                dispatch(requestSolidarityCardError());
            }
        });
};

const confirmSolidarityCardFetching = () => {
    return {
        type: actionTypes.OK_WIZARD_CONFIRM_SOLIDARITY_CARD_FETCHING
    };
};

const confirmSolidarityCardSuccess = payload => {
    return {
        type: actionTypes.OK_WIZARD_CONFIRM_SOLIDARITY_CARD_SUCCESS,
        payload
    };
};

const confirmSolidarityCardError = () => {
    return {
        type: actionTypes.OK_WIZARD_CONFIRM_SOLIDARITY_CARD_ERROR
    };
};

const resetSolidarityOperation = () => {
    return {
        type: actionTypes.OK_WIZARD_SOLIDARITY_RESET
    };
};

const confirmSolidarityCard = (data, body) => dispatch => {
    dispatch(confirmSolidarityCardFetching());

    const requestData = {
        query: body
    };

    return APIPost({
        dispatch,
        endpoint: "cardsSolidarityData",
        url: apiURLBuilder.getURL("cardsSolidarityData", {
            data
        }),
        params: requestData
    })
        .then(response => dispatch(confirmSolidarityCardSuccess(response)))
        .catch(error => dispatch(confirmSolidarityCardError(error)));
};

const confirmSolidarityCardTest = data => (dispatch, getState) => {
    const callback = (dispatch, getState, dataToken) => {
        const minAmount = getState().okWizardSolidarity.get("minAmount");
        const maxAmount = getState().okWizardSolidarity.get("maxAmount");
        const ngos = getState().okWizardSolidarity.get("ngos");
        const ngosID = ngos.map(ngo => ngo.ngoId);

        const body = {
            minAmount,
            maxAmount,
            ngos: ngosID,
            firma: { dataToken }
        };

        dispatch(confirmSolidarityCard(data, body));
    };

    new Promise(() => {
        signaturePatternActions.validateAndExecute(
            dispatch,
            getState,
            callback
        );
    });
};

const confirmSolidarityCreateNewCard = body => (dispatch) => {
    dispatch(confirmSolidarityCardFetching());

    const requestData = {
        query: body
    };

    return APIPost({
        dispatch,
        endpoint: "cardsSolidarityCreateFromExistent",
        // url: apiURLBuilder.getURL("cardsSolidarityCreateFromExistent"),
        params: requestData
    })
        .then(response => dispatch(confirmSolidarityCardSuccess(response)))
        .catch(error => dispatch(confirmSolidarityCardError(error)));
};

const confirmSolidarityCardNotFound = (contract, pan) => (
    dispatch,
    getState
) => {
    const callback = (dispatch, getState, dataToken) => {
        const minAmount = getState().okWizardSolidarity.get("minAmount");
        const maxAmount = getState().okWizardSolidarity.get("maxAmount");
        const ngos = getState().okWizardSolidarity.get("ngos");
        const ngosID = ngos.map(ngo => ngo.ngoId);

        const body = {
            firma: {
                dataToken
            },
            minAmount,
            maxAmount,
            ngos: ngosID,
            contract,
            pan,
        };

        dispatch(confirmSolidarityCreateNewCard(body));
    };

    signaturePatternActions.validateAndExecute(dispatch, getState, callback);
};

const setNGOsData = payload => {
    return {
        type: actionTypes.OK_WIZARD_SET_NGOS_DATA,
        payload
    };
};

const validateStep = step => {
    return {
        type: actionTypes.OK_WIZARD_SOLIDARITY_VALIDATE_STEP,
        step
    };
};

const setVisibleStep = step => {
    return {
        type: actionTypes.OK_WIZARD_SOLIDARITY_SET_VISIBLE_STEP,
        step
    };
};

const setWillCancel = () => {
    return {
        type: actionTypes.OK_WIZARD_SOLIDARITY_SET_WILL_CANCEL
    };
};

const setMinAmountLimit = payload => {
    return {
        type: actionTypes.OK_WIZARD_SOLIDARITY_SET_MIN_AMOUNT_LIMIT,
        payload
    };
};

const setMaxAmountLimit = payload => {
    return {
        type: actionTypes.OK_WIZARD_SOLIDARITY_SET_MAX_AMOUNT_LIMIT,
        payload
    };
};

module.exports = {
    requestSolidarityCard,
    confirmSolidarityCardTest,
    confirmSolidarityCardNotFound,
    setNGOsData,
    validateStep,
    setVisibleStep,
    setWillCancel,
    setMinAmountLimit,
    setMaxAmountLimit,
    resetSolidarityOperation
};
